import { createBrowserRouter } from 'react-router-dom';
import { Layout } from '../components';
//import Dashboard from '../components/Dashboard/Dashboard'
import { ErrorPage } from '../error-page';
import {
  AdminDashboardScreen,
  AppAnalytics,
  ApplicationsScreen,
  CreateCustomerScreen,
  ExploreScreen,
  FirebaseSessionScreen,
  IntegrationDetails,
  IntegrationDetailsForPublicData,
  LandingScreen,
  LoaderScreen,
  ManualVerificationScreen,
  MyProvidersScreen,
  NewApplicationScreen,
  PaymentScreen,
  PaymentStatusScreen,
  ProfileScreen,
  ProviderEditScreen,
  ProvidersScreen,
  PublicDataVerificationScreen,
  SettingsScreen,
} from '../screens';
import FeatureFlagsScreen from '../screens/feature-flags/feature-flags';
import { ProtectedRouteWrapper } from '../screens/landing/components/protected-route-wrapper/protected-route-wrapper.component';
import { MyApplicationsScreen } from '../screens/my-applications/my-application.screen';
import { RedirectScreen } from '../screens/provider-builder-redirect/redirect-screen';
import { ProviderBuilderV3Screen } from '../screens/provider-builder/provider-builder.screen';
import { ApplicationEditScreen } from '../screens/application-edit/application-edit.screen';
import { IntegrationDetailsScreen } from '../screens/bluecheck-integration-details/bluecheck-integration-details.screen';
//import AddProvider from './AddProvider'

export const routerConfig = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/',
        element: <LandingScreen />,
        errorElement: <ErrorPage />,
      },
      {
        path: '/firebase-session',
        element: <FirebaseSessionScreen />,
        errorElement: <ErrorPage />,
      },
      {
        path: '/dashboard',
        element: (
          <ProtectedRouteWrapper>
            <ApplicationsScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/my-providers',
        element: (
          <ProtectedRouteWrapper>
            <MyProvidersScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/my-applications',
        element: (
          <ProtectedRouteWrapper>
            <MyApplicationsScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/my-applications/:appId',
        element: (
          <ProtectedRouteWrapper>
            <AppAnalytics />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/applications',
        element: (
          <ProtectedRouteWrapper>
            <ApplicationsScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/new/public-data',
        element: (
          <ProtectedRouteWrapper>
            <PublicDataVerificationScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/providers',
        element: (
          <ProtectedRouteWrapper>
            <ProvidersScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/profile',
        element: <ProfileScreen />,
        errorElement: <ErrorPage />,
      },
      {
        path: '/settings',
        element: <SettingsScreen />,
        errorElement: <ErrorPage />,
      },
      {
        path: '/new-application',
        element: (
          <ProtectedRouteWrapper>
            <NewApplicationScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/edit-application/:appId',
        element: (
          <ProtectedRouteWrapper>
            <NewApplicationScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/admin/dashboard',
        element: (
          <ProtectedRouteWrapper>
            <AdminDashboardScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/admin/feature-flags',
        element: (
          <ProtectedRouteWrapper>
            <FeatureFlagsScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/explore',
        element: (
          <ProtectedRouteWrapper>
            <ExploreScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/provider/:id',
        element: (
          <ProtectedRouteWrapper>
            <ProviderEditScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/admin-edit-application/:appId',
        element: (
          <ProtectedRouteWrapper>
            <ApplicationEditScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/tutorials',
        element: <ErrorPage />,
        errorElement: <ErrorPage />,
      },
      {
        path: '/provider-builder',
        element: (
          <ProtectedRouteWrapper>
            <ProviderBuilderV3Screen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/my-applications/code-preview/:appId',
        element: (
          <ProtectedRouteWrapper>
            <IntegrationDetails />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/my-applications/bluecheck-code-preview/:appId',
        element: (
          <ProtectedRouteWrapper>
            <IntegrationDetailsScreen createdApp={null} />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/edit-application/code-preview/:appId',
        element: (
          <ProtectedRouteWrapper>
            <IntegrationDetails />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/public-data/preview/:appId',
        element: (
          <ProtectedRouteWrapper>
            <IntegrationDetailsForPublicData />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/welcome',
        element: <LandingScreen />,
        errorElement: <ErrorPage />,
      },
      {
        path: '/admin/init',
        element: <LoaderScreen />,
        errorElement: <ErrorPage />,
      },
      {
        path: '/manual-verification',
        element: (
          <ProtectedRouteWrapper>
            <ManualVerificationScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/manual-verification/sessions/:sessionId',
        element: (
          <ProtectedRouteWrapper>
            <ManualVerificationScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/payment',
        element: (
          <ProtectedRouteWrapper>
            <PaymentScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },

      {
        path: '/payment/status',
        element: (
          <ProtectedRouteWrapper>
            <PaymentStatusScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
      {
        path: '/create-customer',
        element: (
          <ProtectedRouteWrapper>
            <CreateCustomerScreen />
          </ProtectedRouteWrapper>
        ),
        errorElement: <ErrorPage />,
      },
    ],
  },
  {
    path: '/devtool/redirect',
    element: <RedirectScreen />,
    errorElement: <ErrorPage />,
  },
]);
